<template>
  <div style="height:100%;">
    <div class="ifbox">
      <iframe id="iframeLive" ref="iframeLive" class="iframeLive" scrolling="no" allowfullscreen="true"
        webkitallowfullscreen="true" mozallowfullscreen="true" oallowfullscreen="true" msallowfullscreen="true"
        :src="LiveSrc"></iframe>
      <div class="fanhuibtn" v-show="back != ''" @click="toback()">返回</div>
      <div class="timebox" v-show="time > 0">试看倒计时{{ time }}s | <a href="javascript:0" @click="toLogin">登录</a></div>
    </div>
    <div class="guanggao" v-if="isguanggao">
      <img :src="guanggaosrc" alt="" @click="toLink">
      <i class="el-icon-close" @click.stop="isguanggao = false"></i>
    </div>
    <div class="box" :style="'top:' + (LiveStreamType == 1 ? '74.5vw' : '56vw')">
      <van-tabs :ellipsis="false" v-if="menulist.length > 0" style="width:100%">
        <van-tab v-for="(item, index) in menulist" :key="index" :title="item.name">
          <div class="bbox" v-if="item.type != 5">
            <!-- 图文 -->
            <div class="tuwenbox" v-if="item.type == 2">
              <div v-if="item.liveDetailList.length > 0" v-html="item.liveDetailList[0].contents"></div>
            </div>
            <!-- 视频 -->
            <div class="video display_flex" v-else-if="item.type == 3">
              <div v-for="(items, indexs) in item.liveDetailList" :key="indexs + 's'" class="videoBox"
                @click="breadclk(items)">
                <div class="video-card">
                  <img :src="items.coverPictureUrl" class="cont_img" alt="">
                  <img src="../../assets/img/icon/bofang3.png" class="btn" @click="toShipin(items)" alt="">
                  <div class="title ng-star-inserted">
                    <p>{{ items.title }}</p>
                  </div>
                </div>
              </div>
            </div>
            <!-- 链接 -->
            <div class="link" v-else-if="item.type == 4">
              <div v-for="(items, indexs) in item.liveDetailList" :key="indexs + 's'" class="linkBox"
                @click="linkclk(items)">
                <div class="display_center_lr" style="width:100%" v-if="items.coverPictureUrl != ''">
                  <img :src="items.coverPictureUrl" style="cursor: pointer" width="100%" />
                </div>
              </div>
            </div>
            <div v-else-if="item.type == 5"></div>
          </div>
        </van-tab>
      </van-tabs>
      <van-popup v-model="isShipin" style="width:80%" @close="shipinClose">
        <div id="shipin"></div>
      </van-popup>
    </div>
  </div>
</template>

<script>
import Player from 'xgplayer';
import { Dialog } from 'vant';
import { Toast } from 'vant';
export default {
  name: "muduLive",
  data() {
    return {
      lId: 0, //直播id
      LiveSrc: '',
      menulist: [],
      menutype: 0,
      linkList: [],
      breadList: [],
      content: '',
      AuthorId: 0,
      isShipin: false,
      shipinTitle: '',
      player: null,
      mtgId: 0,
      liveType: 1,
      LiveStreamType: 0,
      qid: 0,
      back: '',
      authType: 1,
      time: 0,
      bgimg: '',
      wcUserId: 0,
      isguanggao: false,
      guanggaourl: '',
      guanggaosrc: '',
      isSign: false
    }
  },
  methods: {
    isMobile() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
      return flag;
    },
    /**登录*/
    toLogin() {
      let callback = encodeURIComponent(window.location.href);
      window.location.href = this.httphelper.IsDebugH5GP519() + '/pages/login/login?callback=' + callback;
    },
    /**获取微信code*/
    towxLogin() {
      let callback = encodeURIComponent(window.location.href);
      this.$router.push({
        name: 'wxlogin',
        query: {
          url: callback
        }
      })
    },
    /**获取直播配置信息*/
    getLiveRes() {
      this.httphelper.post('/api/LiveApi/GetLiveRegistSetById', {
        id: this.lId,
        liveType: this.liveType
      }).then(res => {
        if (res.data.code == 200) {
          this.authType = res.data.data.authType
          this.isSign = res.data.data.isSign
          this.$h5weixinshare.WeiXinShare(res.data.data.shareTitle, window.location.href, res.data.data.shareText, res.data.data.shareUrl);
          if (Object.keys(this.$route.query).length > 0 && Object.prototype.hasOwnProperty.call(this.$route.query,
            'back')) {
            this.back = this.$route.query.back
          }
          //判断授权方式:authType (1:微信登录 2:手机号登录 3:免登录)
          if (this.authType == 1) {
            let info = this.$cookies.get('meetingkey')
            if (info) {
              if (info.type == 1) {
                this.AuthorId = Number(info.userid)
              } else if (info.type == 2) {
                this.wcUserId = Number(info.userid);
              } else {
                this.$cookies.remove('meetingkey');
              }
              this.toLive()
            } else if (Object.keys(this.$route.query).length > 0 && Object.prototype.hasOwnProperty.call(this.$route.query, 'code')) {
              this.wechatlogin(this.$route.query.code)
            } else {
              this.towxLogin()
            }
          } else if (this.authType == 2) {
            let trytimess = res.data.data.tryTimes * 60; //获取试看时长
            this.$cookies.remove('meetingkey');
            // 判断本地cookie是否存在
            if (this.$cookies.isKey('token_chinagp') && !Object.prototype.hasOwnProperty.call(this.$route.query, 'tokenkey')) {
              var _tokenkey = this.$cookies.get('token_chinagp');
              //校验token是否有效 
              this.httphelper
                .post('/api/LoginApi/CheckToken', {
                  tokenKey: _tokenkey
                })
                .then(res => {
                  if (res.data.code == 200) {
                    this.$cookies.set('token_chinagp', _tokenkey);
                    //访问直播页面
                    this.time = 0;
                    this.AuthorId = res.data.data.id;
                    this.toLive();
                  } else {
                    this.time = trytimess; //获取试看时长
                    this.usertryplay(this.time)
                  }
                });
            }
            //判断url中是否存在tokenkey
            //校验token是否有效
            else if (Object.keys(this.$route.query).length > 0 && Object.prototype.hasOwnProperty.call(this.$route.query, 'tokenkey')) {
              this.httphelper
                .post('/api/LoginApi/CheckToken', {
                  tokenKey: this.$route.query.tokenkey
                })
                .then(res => {
                  if (res.data.code == 200) {
                    this.$cookies.set('token_chinagp', this.$route.query.tokenkey);
                    let curl = this.delUrlData(window.location.href, "tokenkey");
                    window.location.href = curl;
                    this.time = 0;
                    //访问直播页面
                    this.AuthorId = res.data.data.id;
                    this.toLive();
                  } else {
                    this.time = trytimess; //获取试看时长
                    this.usertryplay(this.time)
                  }
                });
            } else {
              this.time = trytimess; //获取试看时长
              this.usertryplay(this.time)

            }
          }
          //免登录
          else if (this.authType == 3) {
            this.getMeetingInfo()
            //获取授权地址
            this.GetUserAuth();
            //菜单绑定
            this.getLiveMenuById();
          }
        }
      })
    },
    /**用户是试看 */
    usertryplay(tryTimes) {
      this.time = tryTimes; //获取试看时长
      if (this.time > 0) {
        this.getMeetingInfo()
        //获取授权地址
        this.GetUserAuth();
        //菜单绑定
        this.getLiveMenuById();
      } else {
        Dialog.alert({
          title: '提示',
          message: '请先登录',
        })
          .then(() => {
            this.toLogin()
          })
      }
      var test2 = setInterval(() => {
        this.time--
        if (this.time <= 0) {
          clearInterval(test2);
          this.LiveSrc = this.bgimg
          Dialog.alert({
            title: '提示',
            message: tryTimes == 0 ? '请先登录后观看' : '试看结束，请先登录后观看',
          })
            .then(() => {
              this.toLogin()
            })
        }
      }, 1000)
    },
    delUrlData(url, name) {
      var urlparts = url.split('?');
      if (urlparts.length >= 2) {
        //参数名前缀
        var prefix = encodeURIComponent(name) + '=';
        var pars = urlparts[1].split(/[&;]/g);

        //循环查找匹配参数
        for (var i = pars.length; i-- > 0;) {
          if (pars[i].lastIndexOf(prefix, 0) !== -1) {
            //存在则删除
            pars.splice(i, 1);
          }
        }
        return urlparts[0] + (pars.length > 0 ? '?' + pars.join('&') : '');
      }
      return url;
    },
    /**获取微信返回code值后微信登录 */
    wechatlogin(wechatcode) {
      this.httphelper
        .post('/api/CGpUserApi/WeChatUserLoginNew', {
          code: wechatcode,
          id: 0,
          LoginType: 3
        })
        .then(res => {
          if (res.data.code == 200) {
            var userinfo = {
              userid: res.data.data.id,
              type: 1
            };
          } else if (res.data.code == 235) {
            var userinfo = {
              userid: res.data.data.id,
              type: 2
            };
          } else if (res.data.code == 500) {
            var userinfo = {
              userid: 0,
              type: 3
            };
          }
          this.$cookies.set('meetingkey', JSON.stringify(userinfo));
          let info = this.$cookies.get('meetingkey')
          if (info) {
            window.location.href = this.delUrlData(this.delUrlData(window.location.href, 'code'), 'state')
          }

        });
    },
    /**获取目睹授权地址 */
    GetUserAuth() {
      let _this = this;
      _this.httphelper.post('/api/LiveApi/GetUserAuth', {
        id: parseInt(_this.lId),
        assign_id: this.AuthorId.toString(),
        expire: 7200,
        tourl: '',
        wcUserId: this.wcUserId
      }).then(res => {
        if (res.data.code == 200) {
          let data = res.data.data;
          _this.LiveSrc = data;
          _this.getGuanggao()
        }
      });
    },
    /**获取广告 */
    getGuanggao() {
      this.httphelper.post('/api/LiveApi/GetMtgLiveAdvert', {
        id: this.lId,
        liveType: 1
      }).then(res => {
        if (res.data.code == 200 && res.data.data) {
          this.guanggaosrc = res.data.data.advertResUrl
          this.guanggaourl = res.data.data.hyperlink
          this.isguanggao = res.data.data.isOpen
        }
      });
    },
    /**获取直播配置菜单 */
    getLiveMenuById() {
      let _this = this;
      _this.httphelper.post('/api/LiveApi/getLiveMenuById', {
        Id: _this.lId,
        LiveType: 1
      }).then(res => {
        if (res.data.code == 200 && res.data.data) {
          _this.menulist = res.data.data
        }
      });
    },
    toback() {
      window.location.href = decodeURIComponent(this.back)
    },
    /**超级链接跳转 */
    linkclk(item) {
      window.open(item.hyperlinks);
    },
    toLink() {
      window.open(this.guanggaourl)
    },
    /**打开视频弹框 */
    toShipin(item) {
      this.shipinTitle = item.title
      this.isShipin = true
      var test1 = setTimeout(() => {
        this.player = new Player({
          id: 'shipin',
          url: item.resUrl,
          autoplay: true,
          playsinline: true,
          width: '100%',
          height: 'auto'
        });
        clearTimeout(test1);
      }, 100);
    },
    /**视频弹框关闭 */
    shipinClose() {
      if (this.player != null) {
        this.player.destroy();
        this.player = null;
      }
      this.isShipin = false
    },
    /** 跳转到会议报名页面*/
    regclick(cpg) {
      if (this.$cookies.isKey('token_chinagp')) {
        var _tokenkey = this.$cookies.get('token_chinagp');
        this.httphelper
          .post('/api/LoginApi/CheckToken', {
            tokenKey: _tokenkey
          })
          .then(res => {
            if (res.data.code == 200) {
              if (res.data.data.mobile == '' || res.data.data == null) {
                this.Defconfirm();
                return;
              }
              if (cpg > 0) {
                if (!this.isDebug) {
                  window.location.href = 'https://meeting.gp519.com/reg?mtgid=' + this.mtgId + '&cgp=' + cpg;
                } else {
                  window.location.href = 'https://meeting.gp519.com/reg?mtgid=' + this.mtgId + '&cgp=' + cpg;
                }
              } else {
                if (!this.isDebug) {
                  window.location.href = 'https://meeting.gp519.com/reg?mtgid=' + this.mtgId;
                } else {
                  window.location.href = 'https://meeting.gp519.com/reg?mtgid=' + this.mtgId;
                }
              }
            } else {
              if (!this.isDebug) {

                let callback = encodeURIComponent('https://meeting.gp519.com/reg?mtgid=' + this.mtgId);
                window.location.href = this.httphelper.IsDebugH5GP519() + '/pages/login/login?callback=' + callback;
              } else {

                let callback = encodeURIComponent('https://meeting.gp519.com/reg?mtgid=' + this.mtgId);
                window.location.href = this.httphelper.IsDebugH5GP519() + '/pages/login/login?callback=' + callback;
              }
            }
          });
      } else if (Object.keys(this.$route.query).length > 0 && Object.prototype.hasOwnProperty.call(this.$route.query,
        'tokenkey')) {
        this.httphelper
          .post('/api/LoginApi/CheckToken', {
            tokenKey: this.$route.query.tokenkey
          })
          .then(res => {
            if (res.data.code == 200) {
              if (res.data.data.mobile == '' || res.data.data == null) {
                this.Defconfirm();
                return;
              }
              if (cpg > 0) {
                if (!this.isDebug) {
                  window.location.href = 'https://meeting.gp519.com/reg?mtgid=' + this.mtgId + '&cgp=' + cpg;
                } else {
                  window.location.href = 'https://meeting.gp519.com/reg?mtgid=' + this.mtgId + '&cgp=' + cpg;
                }
              } else {
                if (!this.isDebug) {
                  window.location.href = 'https://meeting.gp519.com/reg?mtgid=' + this.mtgId;
                } else {
                  window.location.href = 'https://meeting.gp519.com/reg?mtgid=' + this.mtgId;
                }
              }
            } else {
              if (!this.isDebug) {

                let callback = encodeURIComponent('https://meeting.gp519.com/reg?mtgid=' + this.mtgId);
                window.location.href = this.httphelper.IsDebugH5GP519() + '/pages/login/login?callback=' + callback;
              } else {

                let callback = encodeURIComponent('https://meeting.gp519.com/reg?mtgid=' + this.mtgId);
                window.location.href = this.httphelper.IsDebugH5GP519() + '/pages/login/login?callback=' + callback;
              }
            }
          });
      } else {
        var hrefurl = '';
        if (cpg == 0) {
          if (!this.isDebug) {
            hrefurl = 'https://meeting.gp519.com/reg?mtgid=' + this.mtgId;
          } else {
            hrefurl = 'https://meeting.gp519.com/reg?mtgid=' + this.mtgId;
          }
        } else {
          if (!this.isDebug) {
            hrefurl = 'https://meeting.gp519.com/reg?mtgid=' + this.mtgId + '&cgp=' + cpg;
          } else {
            hrefurl = 'https://meeting.gp519.com/reg?mtgid=' + this.mtgId + '&cgp=' + cpg;
          }
        }
        let callback = encodeURIComponent(hrefurl);
        window.location.href = this.httphelper.IsDebugH5GP519() + '/pages/login/login?callback=' + callback;

      }
    },
    Defconfirm() {
      this.$confirm('会议报名必须先完善个人信息, 是否前往用户中心完善个人信息?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$router.push({ name: 'userInfor' });
      });
    },

    /**进入直播间 */
    toLive() {
      if (this.$route.query.LiveStreamType == 1) {
        this.LiveStreamType = 1
      }
      let _this = this
      if (_this.$route.query.mid != '' && _this.$route.query.mid != null && _this.$route.query.mid != '0') {
        _this.mtgId = _this.$route.query.mid;
      } else {
        _this.mtgId = 0;
      }

      if (_this.isSign) {
        //验证是否需要报名
        _this.httphelper.post('/api/LiveApi/GetLiveRegistSet', {
          liveId: _this.lId,
          liveType: _this.liveType,
          mtgId: parseInt(_this.mtgId),
          userId: _this.AuthorId
        }).then(res => {
          if (res.data.code != 200) {
            //请先报名
            _this.regclick(0);
          } else {
            _this.CheckIsQuestionnaire();
          }
        });
      } else {
        _this.CheckIsQuestionnaire();
      }
    },

    /** 验证是否需要问卷 */
    CheckIsQuestionnaire() {
      this.httphelper.get('/api/LiveApi/CheckIsQuestionnaire?mid=' + this.mtgId + '&liveid=' + this.lId + '&livetype=' + parseInt(this.liveType)).then(res => {
        if (res.code == 200) {
          this.getMeetingInfo()
          //获取授权地址
          this.GetUserAuth();
          //菜单绑定
          this.getLiveMenuById();
        } else {
          if (res.code == 20) {
            this.qid = res.data.id
            let info = this.$cookies.get('meetingkey');
            let userid = this.AuthorId;
            if (info) {
              if (info.type == 1) {
                userid = Number(info.userid)
              } else if (info.type == 2) {
                userid = Number(info.userid);
              }
            } 
            //验证当前用户是否报名
            this.httphelper.get('/api/QuestionnaireApi/CheckIsFeedbackList?qid=' + res.data.id + '&userid=' + userid+'&expiretype='+res.data.expireType).then(res => {
              if (res.code == 200) {
                this.getMeetingInfo()
                //获取授权地址
                this.GetUserAuth();
                //菜单绑定
                this.getLiveMenuById();
              } else {
                //跳转调查问卷 
                // Dialog.alert({
                //   title: '提示',
                //   message: '请先填写调查问卷',
                // })
                //   .then(() => {

                //   })
                let callback = encodeURIComponent(window.location.href);
                this.$router.push({
                  path: '/question?',
                  query: {
                    qid: this.qid,
                    callback: callback,
                    tokenkey: this.$route.query.tokenkey,
                    ulogintype: this.authType
                  },
                })
              }
            });
          } else {
            Toast.fail(res.msg);
          }
        }
      });
    },
    /**获取直播间名称和背景图 */
    getMeetingInfo() {
      let _this = this;
      _this.httphelper.post('/api/LiveApi/GetMuduLiveById', {
        id: _this.lId,
        liveType: 0
      }).then(res => {
        if (res.data.code == 200) {
          document.title = res.data.data.name || '全科医学网'
          this.bgimg = res.data.data.live_img
        }
      });
    },
  },
  created() {
    if (this.isMobile()) {
      if (this.$route.query.id) this.lId = this.$route.query.id
      this.getLiveRes()
    } else {
      window.location.href = window.location.href.replace(/muduLiveMobile/, "muduLive")
    }
  }
}
</script>
 

<style scoped>
.ifbox {
  width: 100%;
  /* height: 664px; */
  height: 100%;
  /* height: 202vw; */
  display: flex;
  justify-content: center;
  /* background-repeat: center; */
  /* background-size: 1925px 1100px; */
  /* background-image: url('../../assets/img/livebg2.png'); */
  background-color: #eaf2fe;
  /* background-image: linear-gradient(to bottom, #e7f0fe, #f4f7fd, #f4f7fd); */
  /* background-position: 50% 0; */
  overflow: hidden;
  position: relative;
}

.timebox {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 10000;
  display: inline-block;
  height: 22px;
  line-height: 12px;
  font-size: 12px;
  padding: 5px;
  box-sizing: border-box;
  background-color: rgb(206, 35, 35);
  color: #fff;
  border-radius: 15px;
}

.timebox a {
  color: #fff;
  line-height: 12px;
}

.fanhuibtn {
  position: absolute;
  bottom: 10px;
  right: 10px;
  width: 40px;
  height: 26px;
  font-size: 12px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  background-color: #448aff;
  cursor: pointer;
  z-index: 100000;
}

.iframeLive {
  /* min-width: 1378px;
    width: 1378px;
    height: 10000px; */
  border: none;
  overflow: hidden;
  width: 100%;
  height: 100%;
}

.btitle {
  height: 60px;
  font-weight: 800;
  font-size: 18px;
}

.btitle img {
  margin-right: 20px;
}

.body {
  padding: 30px 0 70px;
}

.tuwenbox {
  padding: 10px 10px;
}
</style>

<style lang="scss" scoped>
.guanggao {
  position: fixed;
  width: 96%;
  height: 40px;
  top: calc(56vw + 55px);
  left: 2%;
  background-color: #fff;
  z-index: 10000;
  border-radius: 20px;
  overflow: hidden;

  img {
    width: 100%;
    height: 40px;
  }

  i {
    position: absolute;
    top: 0px;
    right: 10px;
    font-size: 30px;
    line-height: 40px;
  }
}

.box {
  width: 100%;
  position: absolute;

  .bbox {
    // height: 75vh;
    height: calc(100vh - 56vw - 44px);
    overflow: auto;
    background-color: #fff;
  }
}

.video {
  flex-wrap: wrap;
}

.videoBox {
  width: 46%;
  margin-left: 2.5%;
  margin-bottom: 10px;
}

.video-card {
  width: 100%;
  height: 140px;
  padding: 7px 10px;
  background-color: #f6f4fa;
  box-sizing: border-box;
  position: relative;
}

.video-card .cont_img {
  width: 100%;
  height: 80px;
  border-radius: 5px 5px 0 0;
}

.video-card .btn {
  position: absolute;
  top: 30px;
  left: 70px;
  cursor: pointer;
}

.video-card .title {
  height: 46px;
  border-radius: 0 0 5px 5px;
  background-color: #fff;
  margin-top: -3px;
  padding: 4px 5px 6px;
  box-sizing: border-box;
}

.video-card p {
  height: 36px;
  line-height: 18px;
  font-size: 12px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}

.link {
  flex-wrap: wrap;
  padding-top: 10px;
}

.linkBox {
  width: 46%;
  margin-left: 2.5%;
  margin-bottom: 10px;
}

#shipin ::v-deep .xgplayer-icon {
  margin-top: 0;
  bottom: 0;
  height: 32px;
}
</style>